import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class LogbooksSharedService {
  private pilots_TotalOperationsByDroneSource = new BehaviorSubject<string>(null);
  svg$ = this.pilots_TotalOperationsByDroneSource.asObservable();

  setPilotsTotalOperationsByDroneSvg(svg: string) {
    this.pilots_TotalOperationsByDroneSource.next(svg);
  }

  convertSvgToBase64(svg: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const DOMURL = (window.URL || window.webkitURL || window) as typeof window.URL;

      const img = new Image();
      const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
      const url = DOMURL.createObjectURL(svgBlob);

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0);
        const base64Image = canvas.toDataURL('image/png');
        DOMURL.revokeObjectURL(url);
        resolve(base64Image);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }
}
